<template>
  <v-container grid-list-xs class="pa-0 ma-0" fluid>
    <v-row class="no-gutters titlesdark--text">
      <v-col md="8" sm="12" class="pa-0 ma-0 mt-1">
        <span class="pl-1 text-light font-size-2">{{tituloGrids}}</span>
      </v-col>
    </v-row>
    <v-row class="no-gutters mt-2">
    <v-col md="12" sm="12" class="pa-0 ma-0">
      <grid
        :key="nKey"
        v-if="this.$store.state.token!=''"
        :tabla="TablaName"
        :bActiveFilter="true"
        :bActiveExport="true"
        :bSingleSelect="true"
        :bShowSelect="false"
        :sIdTable="'idPrioridad_requerimiento,idDependencia,Departamento_idDepartamento'"
        :bShowMapDetails="false"
        :bActiveNew="false"
        @saveOk="createDetaill"
        @idSelect="getIdSelect"
        @nameField="getNameFieldSelect"
      >
        <template v-slot:slotbtnNew>
          <v-btn class="no-uppercase d-flex mx-2 my-1" small depressed dark color="primary" @click="bFormularioAsocialTiempo = true" rounded>
            <v-icon left>mdi-send</v-icon> 
            {{ $store.state.jsIdioma.oEquivalencias.btnAsociarTiempos }}
          </v-btn>
        </template>
        <template v-slot:slot-grid-anidada="props" >
          <div v-if="onExtraerIdSelectGridAnidada(props.item)!=0">
            {{props}}
            {{onExtraerIdSelectGridAnidada(props.item)}}
          </div>
            <!-- v-if="onExtraerIdSelectGridAnidada(props.item)!=0" -->
          </template>
      </grid>  
    </v-col>
    </v-row>
    <FormAsociarTiempos 
      v-if="bFormularioAsocialTiempo"
      v-model="bFormularioAsocialTiempo"
      @guardado="onGuardado"
      />
  </v-container>
</template>
<script>
import grid from '@/components/Grid/Grid.vue'
import mxFunciones from '@/mixins/funciones.js'
import FormAsociarTiempos  from '@/components/Seif/pqr/FormAsociarTiempos.vue'

export default {
  name: 'PQRTiemposGestion',
  components: {
    grid,
    FormAsociarTiempos
  },
  mixins: [mxFunciones],
  data() {
    return {
      bFormularioAsocialTiempo: false,
      TablaName : 'PQR_PrioridadesXDependencias_Tiempo',    // Nombre de la tabla a trabajar           // Id seleccionado
      nIdSeleccionado  : 0,
      sNombreCampoFiltro : '',
      nKey: 0,

    }
  },
  async mounted() {
    this.onValidarTokenSinLogin()
    this.tituloGrids = await this.getTitulo(this.TablaName)
  },
  methods: {
    onGuardado() {
      this.nKey++
    },
    getIdSelect(sIdSelected) {
      //console.log(sIdSelected)
      this.nIdSeleccionado = sIdSelected;
    },
    getNameFieldSelect(sNameFiled) {
      this.sNombreCampoFiltro = sNameFiled;
    },
    createDetaill() {
      return false
    },
  },
  
}
</script>